module.exports = __webpack_public_path__ + "static/media/LOGO-BUSINESS.161f95db.png";